import type { PImage } from '../../../engine/aliases'
import type { IEntity } from '../../../entities/entitiesUtils'
import { entitiesUtils } from '../../../entities/entitiesUtils-sidecar'
import { l } from '../../../lib/imports'
import { common } from '../../../main/common-sidecar'
import { sprites } from '../../../sprites/sprites-sidecar'
import { spritesUtil } from '../../../sprites/spritesUtil-sidecar'
import { voyageLayers } from '../voyageLayers-sidecar'
import type { IVoyageLocation } from './voyageStarmapLocationData'

export interface IVoyageStarmapTile extends IEntity {
  x: number
  y: number
  i: number
  j: number

  isVisited: boolean
  isRevealed: boolean

  imageBack: PImage
  imageLocation: PImage | null
  imageDanger: PImage | null

  location: IVoyageLocation | null

  // hasBackgroundAsteroids: boolean
}

const objs: IVoyageStarmapTile[] = []

export function create(
  i: number,
  j: number,
  x: number,
  y: number,
): IVoyageStarmapTile {
  let id = common.createId()

  let imageBack = spritesUtil.createImage(
    voyageLayers.getLayers().starmapBack,
    sprites.voyStarmapHidden[0],
  )
  imageBack.x = x
  imageBack.y = y

  let obj: IVoyageStarmapTile = {
    eType: 'tile-starmap',
    id,
    idLoaded: 0,
    isDead: false,
    imageBack,
    imageLocation: null,
    imageDanger: null,
    location: null,
    isRevealed: false,
    isVisited: false,
    x,
    y,
    i,
    j,
    // hasBackgroundAsteroids: false,
  }
  objs.push(obj)
  updateBack(obj)
  return obj
}

export function setVisited(tile: IVoyageStarmapTile, isVisited: boolean) {
  tile.isVisited = isVisited
  if (isVisited) {
    tile.isRevealed = true
  }
  updateBack(tile)
  setLocationIcon(tile)
}
export function setScanned(tile: IVoyageStarmapTile, isScanned: boolean) {
  tile.isRevealed = isScanned
  updateBack(tile)
  setLocationIcon(tile)
}

function updateBack(tile: IVoyageStarmapTile) {
  let frame = sprites.voyStarmapHidden
  if (tile.isRevealed) {
    frame = sprites.voyStarmapVisible
  }
  if (tile.isVisited) {
    frame = sprites.voyStarmapVisited
  }
  spritesUtil.setPackedFrame(tile.imageBack, frame[0])
}

function setDangerIcon(tile: IVoyageStarmapTile, dangerLevel: number) {
  if (dangerLevel <= 0) {
    if (tile.imageDanger) {
      tile.imageDanger.destroy()
      tile.imageDanger = null
    }
    return
  }

  let dangerFrame =
    dangerLevel >= 3
      ? sprites.voyStarmapDanger3
      : dangerLevel >= 2
      ? sprites.voyStarmapDanger2
      : sprites.voyStarmapDanger1

  if (dangerFrame) {
    if (!tile.imageDanger) {
      tile.imageDanger = spritesUtil.createImage(
        voyageLayers.getLayers().starmapLocation,
        dangerFrame[0],
      )
      tile.imageDanger.x = tile.x
      tile.imageDanger.y = tile.y
    } else {
      spritesUtil.setPackedFrame(tile.imageDanger, dangerFrame[0])
    }
  } else {
    if (tile.imageDanger) {
      tile.imageDanger.destroy()
      tile.imageDanger = null
    }
  }
}

function setLocationIcon(tile: IVoyageStarmapTile) {
  let location = tile.location
  if (!location) {
    if (tile.imageLocation) {
      tile.imageLocation.destroy()
      tile.imageLocation = null
    }
    setDangerIcon(tile, 0)
  } else {
    let frames = sprites.voyStarmapUnknown
    let dangerLevel = 0
    if (tile.isRevealed) {
      frames = location.frames
      dangerLevel = location.dangerLevel
    }
    if (!tile.imageLocation) {
      tile.imageLocation = spritesUtil.createImage(
        voyageLayers.getLayers().starmapLocation,
        frames[0],
      )
      tile.imageLocation.x = tile.x
      tile.imageLocation.y = tile.y
    } else {
      spritesUtil.setPackedFrame(tile.imageLocation, frames[0])
    }

    setDangerIcon(tile, dangerLevel)
  }
}

export function setLocation(
  tile: IVoyageStarmapTile,
  location: IVoyageLocation | null,
) {
  tile.location = location

  setLocationIcon(tile)

  // if (data && data.hasBackgroundAsteroids) {
  //   tile.hasBackgroundAsteroids = true
  // } else {
  //   tile.hasBackgroundAsteroids = false
  // }
}

export function kill(obj: IVoyageStarmapTile) {
  obj.isDead = true
}

export function killAll() {
  l.forEach(objs, (c) => {
    c.isDead = true
  })
}

export function updateAll() {
  // objs.forEach((c) => {
  //   update(c)
  // })
  entitiesUtils.removeDead(objs, (c) => {
    if (c.imageBack) {
      c.imageBack.destroy()
    }
    if (c.imageLocation) {
      c.imageLocation.destroy()
    }
  })
}
